import React, { Component } from "react";
import { Spinner } from "reactstrap";
import { parseSsoCallback } from "../../../util/ssoEvoltz";
import {
  buildUserConfigs,
  persistSession,
  routeForProfile,
} from "./loginSession";

/**
 * Tela de passagem para onde o backend redireciona depois do SSO Evoltz
 * (`/login/sso/success?token=<jwt>&data=<base64url>`). Grava a sessão e
 * encaminha o usuário para a home do seu perfil.
 *
 * `data` vem da URL, então é entrada não-confiável: se `parseSsoCallback`
 * não conseguir validar o payload, redireciona para o login com erro em
 * vez de renderizar qualquer coisa.
 */
class SsoSuccess extends Component {
  componentDidMount() {
    const parsed = parseSsoCallback(this.props.location.search);

    if (!parsed) {
      this.props.history.replace("/login?ssoError=3");
      return;
    }

    const userConfigs = buildUserConfigs(parsed.details);
    persistSession(parsed.token, userConfigs, parsed.userKey);

    // replace (e não push) para o token sair do histórico e do botão "voltar"
    this.props.history.replace(routeForProfile(userConfigs));
  }

  render() {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <Spinner color="primary" />
      </div>
    );
  }
}

export default SsoSuccess;
